import ReservationStatusEnum from 'enums/reservation_status.enum'
import ReservationActionEnum from 'enums/reservation_action.enum'

export default {
    getReservationActionsByStatus(
        status,
        isOwner,
        isReservationInPast,
        isEventInMoreThanOneMinute,
        isEventInMoreThan20Minutes,
        isEventEligibleToReschedule,
        isEventEligibleToCancel,
        isPublicReservationBlocked,
    ) {
        switch (status) {
            case ReservationStatusEnum.OPEN: {
                const statuses = []

                if (isOwner) {
                    if (isEventInMoreThanOneMinute) {
                        statuses.push(ReservationActionEnum.ACCEPT, ReservationActionEnum.RESCHEDULE)
                    }
                    if (isEventInMoreThan20Minutes) {
                        statuses.push(ReservationActionEnum.DECLINE)
                    }
                    return statuses
                }

                if (isPublicReservationBlocked) {
                    return []
                }

                if (isEventEligibleToReschedule) {
                    statuses.push(ReservationActionEnum.RESCHEDULE)
                }
                if (isEventEligibleToCancel) {
                    statuses.push(ReservationActionEnum.CANCEL)
                }
                return statuses
            }
            case ReservationStatusEnum.OUT_OF_TIME:
                if (isOwner && isEventInMoreThanOneMinute) {
                    return [ReservationActionEnum.CANCEL, ReservationActionEnum.RESCHEDULE]
                }

                if (!isOwner && isPublicReservationBlocked) {
                    return []
                }
                if (!isOwner && isEventEligibleToCancel) {
                    return [ReservationActionEnum.CANCEL]
                }
                return []
            case ReservationStatusEnum.ACCEPTED: {
                const statuses = []

                if (isOwner && isReservationInPast) {
                    return [ReservationActionEnum.DONE, ReservationActionEnum.NO_SHOW]
                }
                if (isOwner && isEventInMoreThanOneMinute) {
                    return [ReservationActionEnum.CANCEL, ReservationActionEnum.RESCHEDULE]
                }

                if (isEventEligibleToReschedule) {
                    statuses.push(ReservationActionEnum.RESCHEDULE)
                }
                if (isEventEligibleToCancel) {
                    statuses.push(ReservationActionEnum.CANCEL)
                }

                if (isPublicReservationBlocked && !isOwner) {
                    return []
                }
                return statuses
            }
            case ReservationStatusEnum.UNAVAILABLE:
                return [ReservationActionEnum.MAKE_AVAILABLE]
            case undefined:
                return [ReservationActionEnum.MAKE_UNAVAILABLE]
            default:
                return []
        }
    },
}
